import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import { FormattedMessage } from 'react-intl';

import { useShortLocale } from '#configuration/lang/useLocale.ts';

type TourDuplicateNotificationsItemProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
};

export const TourDuplicateNotificationsItem = ({ checked, onChange }: TourDuplicateNotificationsItemProps) => {
    const locale = useShortLocale();
    return (
        <li className='list-group-item'>
            <Checkbox custom checked={checked} onChange={event => onChange(event.target.checked)}>
                <div className='checkbox-text-wrapper display-flex justify-content-between align-items-center width-100pct'>
                    <span>
                        <FormattedMessage
                            id='intl-msg:ordercom-cloud-frontend.tours.create-dialog.notifications-link'
                            values={{
                                link: chunks => (
                                    <a
                                        href={`https://rio.cloud/${locale}/documents/manuals/notifications-through-the-bell-icon`}
                                        target='_blank'
                                        rel='noreferrer'
                                        {...getTrackingAttributes({
                                            trigger: 'click',
                                            category: 'link autoTracking',
                                            action: 'link click',
                                            label: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.notifications-link',
                                        })}
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }}
                        />
                    </span>
                    <span className='checkbox-text' />
                </div>
            </Checkbox>
        </li>
    );
};
